export default __webpack_public_path__ + "static/media/message1.185203f2.svg";